// schools
export const ADD_SCHOOL = 'ADD_SCHOOL';
export const SCHOOL_API_REQUEST = 'SCHOOL_API_REQUEST';
export const SCHOOL_API_SUCCESS = 'SCHOOL_API_SUCCESS';
export const SCHOOL_API_FAILURE = 'SCHOOL_API_FAILURE';
export const ADD_SCHOOLS = 'ADD_SCHOOLS';
export const SCHOOLS_API_REQUEST = 'SCHOOLS_API_REQUEST';
export const SCHOOLS_API_SUCCESS = 'SCHOOLS_API_SUCCESS';
export const SCHOOLS_API_FAILURE = 'SCHOOLS_API_FAILURE';
export const ADD_SCHOOLS_PROGRAMS = 'ADD_SCHOOLS_PROGRAMS';
export const SCHOOLS_PROGRAMS_API_REQUEST = 'SCHOOLS_PROGRAMS_API_REQUEST';
export const SCHOOLS_PROGRAMS_API_SUCCESS = 'SCHOOLS_PROGRAMS_API_SUCCESS';
export const SCHOOLS_PROGRAMS_API_FAILURE = 'SCHOOLS_PROGRAMS_API_FAILURE';
export const ADD_SCHOOLS_APPLICATIONS = 'ADD_SCHOOLS_APPLICATIONS';
export const SCHOOLS_APPLICATIONS_API_REQUEST = 'SCHOOLS_APPLICATIONS_API_REQUEST';
export const SCHOOLS_APPLICATIONS_API_SUCCESS = 'SCHOOLS_APPLICATIONS_API_SUCCESS';
export const SCHOOLS_APPLICATIONS_API_FAILURE = 'SCHOOLS_APPLICATIONS_API_FAILURE';
export const ADD_SCHOOLS_SCHEDULING = 'ADD_SCHOOLS_SCHEDULING';
export const SCHOOLS_SCHEDULING_API_REQUEST = 'SCHOOLS_SCHEDULING_API_REQUEST';
export const SCHOOLS_SCHEDULING_API_SUCCESS = 'SCHOOLS_SCHEDULING_API_SUCCESS';
export const SCHOOLS_SCHEDULING_API_FAILURE = 'SCHOOLS_SCHEDULING_API_FAILURE';
export const ADD_STUDENT = 'ADD_STUDENT';
export const STUDENT_API_REQUEST = 'STUDENT_API_REQUEST';
export const STUDENT_API_SUCCESS = 'STUDENT_API_SUCCESS';
export const STUDENT_API_FAILURE = 'STUDENT_API_FAILURE';
export const ADD_STUDENT_APPLICATIONS = 'ADD_STUDENT_APPLICATIONS';
export const STUDENT_APPLICATIONS_API_REQUEST = 'STUDENT_APPLICATIONS_API_REQUEST';
export const STUDENT_APPLICATIONS_API_SUCCESS = 'STUDENT_APPLICATIONS_API_SUCCESS';
export const STUDENT_APPLICATIONS_API_FAILURE = 'STUDENT_APPLICATIONS_API_FAILURE';
export const ADD_STUDENT_PROGRAM = 'ADD_STUDENT_PROGRAM';
export const STUDENT_PROGRAM_API_REQUEST = 'STUDENT_PROGRAM_API_REQUEST';
export const STUDENT_PROGRAM_API_SUCCESS = 'STUDENT_PROGRAM_API_SUCCESS';
export const STUDENT_PROGRAM_API_FAILURE = 'STUDENT_PROGRAM_API_FAILURE';
export const REORDRED_APPLICATION = 'REORDER_APPLICATION';
export const TOGGLE_SCHOOL_HEADER = 'TOGGLE_SCHOOL_HEADER';
export const UPDATE_APPLICATION_RANK_REQUEST = 'UPDATE_APPLICATION_RANK_REQUEST';
export const UPDATE_APPLICATION_RANK_SUCCESS = 'UPDATE_APPLICATION_RANK_SUCCESS';
export const UPDATE_APPLICATION_RANK_FAILURE = 'UPDATE_APPLICATION_RANK_FAILURE';
export const NEW_APPLICATION_RANK = 'NEW_APPLICATION_RANK';
export const NEW_APPLICATION_RANK_DRAG = 'NEW_APPLICATION_RANK_DRAG';
export const GROUP_UPDATE_APPLICATION_RANK_REQUEST = 'GROUP_UPDATE_APPLICATION_RANK_REQUEST';
export const GROUP_UPDATE_APPLICATION_RANK_SUCCESS = 'GROUP_UPDATE_APPLICATION_RANK_SUCCESS';
export const GROUP_UPDATE_APPLICATION_RANK_FAILURE = 'GROUP_UPDATE_APPLICATION_RANK_FAILURE';
export const ADD_GROUP_UPDATE = 'ADD_GROUP_UPDATE';
export const ADD_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE = 'ADD_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE';
export const REQUEST_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE = 'REQUEST_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE';
export const SUCCESS_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE = 'SUCCESS_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE';
export const FAILURE_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE = 'FAILURE_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE';
export const ADD_SAVED_PROGRAM_AUTOCOMPLETE = 'ADD_SAVED_PROGRAM_AUTOCOMPLETE';
export const CLEAR_SAVED_PROGRAM_AUTOCOMPLETE = 'CLEAR_SAVED_PROGRAM_AUTOCOMPLETE';
export const REQUEST_SAVED_PROGRAM_AUTOCOMPLETE = 'REQUEST_SAVED_PROGRAM_AUTOCOMPLETE';
export const SUCCESS_SAVED_PROGRAM_AUTOCOMPLETE = 'SUCCESS_SAVED_PROGRAM_AUTOCOMPLETE';
export const FAILURE_SAVED_PROGRAM_AUTOCOMPLETE = 'FAILURE_SAVED_PROGRAM_AUTOCOMPLETE';
export const ADD_NEW_SCHOOLS_APPLICATIONS = 'ADD_NEW_SCHOOLS_APPLICATIONS';
export const NEW_SCHOOLS_APPLICATIONS_API_REQUEST = 'NEW_SCHOOLS_APPLICATIONS_API_REQUEST';
export const NEW_SCHOOLS_APPLICATIONS_API_SUCCESS = 'NEW_SCHOOLS_APPLICATIONS_API_SUCCESS';
export const NEW_SCHOOLS_APPLICATIONS_API_FAILURE = 'NEW_SCHOOLS_APPLICATIONS_API_FAILURE';
export const ADD_SCHOOLS_AUTOCOMPLETE = 'ADD_SCHOOLS_AUTOCOMPLETE';
export const REQUEST_SCHOOLS_AUTOCOMPLETE = 'REQUEST_SCHOOLS_AUTOCOMPLETE';
export const SUCCESS_SCHOOLS_AUTOCOMPLETE = 'SUCCESS_SCHOOLS_AUTOCOMPLETE';
export const FAILURE_SCHOOLS_AUTOCOMPLETE = 'FAILURE_SCHOOLS_AUTOCOMPLETE';
export const SHOW_POPUP = 'SHOW_POPUP';
export const HIDE_POPUP = 'HIDE_POPUP';
export const ADD_ALERTS = 'ADD_ALERTS';
export const ALERTS_API_REQUEST = 'ALERTS_API_REQUEST';
export const ALERTS_API_SUCCESS = 'ALERTS_API_SUCCESS';
export const ALERTS_API_FAILURE = 'ALERTS_API_FAILURE';
export const LOGGED_OUT_USER_ADDRESS = 'LOGGED_OUT_USER_ADDRESS';
export const CLEAR_LOGGED_OUT_USER_ADDRESS = 'CLEAR_LOGGED_OUT_USER_ADDRESS';
export const COACHMARKS_API_REQUEST = 'COACHMARKS_API_REQUEST';
export const COACHMARKS_API_SUCCESS = 'COACHMARKS_API_SUCCESS';
export const COACHMARKS_API_FAILURE = 'COACHMARKS_API_FAILURE';
export const SET_COACHMARKS = 'SET_COACHMARKS';
export const ADD_STUDENT_WAITLISTS = 'ADD_STUDENT_WAITLISTS';
export const STUDENT_WAITLISTS_API_REQUEST = 'STUDENT_WAITLISTS_API_REQUEST';
export const STUDENT_WAITLISTS_API_SUCCESS = 'STUDENT_WAITLISTS_API_SUCCESS';
export const STUDENT_WAITLISTS_API_FAILURE = 'STUDENT_WAITLISTS_API_FAILURE';
export const ADD_ACCEPTED_OFFERS = 'ADD_ACCEPTED_OFFERS';
export const ADD_ACCEPTED_OFFERS_SUCCESS = 'ADD_ACCEPTED_OFFERS_SUCCESS';
export const ADD_ACCEPTED_OFFERS_FAILURE = 'ADD_ACCEPTED_OFFERS_FAILURE';
export const ADD_OPT_OUT_OFFERS = 'ADD_OPT_OUT_OFFERS';
export const ADD_OPT_OUT_OFFERS_SUCCESS = 'ADD_OPT_OUT_OFFERS_SUCCESS';
export const ADD_OPT_OUT_OFFERS_FAILURE = 'ADD_OPT_OUT_OFFERS_FAILURE';
export const ADD_DECLINED_OFFERS = 'ADD_DECLINED_OFFERS';
export const ADD_DECLINED_OFFERS_SUCCESS = 'ADD_DECLINED_OFFERS_SUCCESS';
export const ADD_DECLINED_OFFERS_FAILURE = 'ADD_DECLINED_OFFERS_FAILURE';
export const ADD_PENDING_WAITLIST_OFFERS = 'ADD_PENDING_WAITLIST_OFFERS';
export const ADD_PENDING_WAITLIST_OFFERS_SUCCESS = 'ADD_PENDING_WAITLIST_OFFERS_SUCCESS';
export const ADD_PENDING_WAITLIST_OFFERS_FAILURE = 'ADD_PENDING_WAITLIST_OFFERS_FAILURE';
export const ADD_NO_RESPONSE_OFFERS = 'ADD_NO_RESPONSE_OFFERS';
export const ADD_NO_RESPONSE_OFFERS_SUCCESS = 'ADD_NO_RESPONSE_OFFERS_SUCCESS';
export const ADD_NO_RESPONSE_OFFERS_FAILURE = 'ADD_NO_RESPONSE_OFFERS_FAILURE';
export const UPDATE_WAITLIST_OFFERS = 'UPDATE_WAITLIST_OFFERS';
export const UPDATE_WAITLIST_OFFERS_SUCCESS = 'UPDATE_WAITLIST_OFFERS_SUCCESS';
export const UPDATE_WAITLIST_OFFERS_FAILURE = 'UPDATE_WAITLIST_OFFERS_FAILURE';
export const WAITLIST_SUBMISSIONS_STATE = 'WAITLIST_SUBMISSIONS_STATE';
export const WAITLIST_SUBMISSIONS_STATE_SUCCESS = 'WAITLIST_SUBMISSIONS_STATE_SUCCESS';
export const WAITLIST_SUBMISSIONS_STATE_FAILURE = 'WAITLIST_SUBMISSIONS_STATE_FAILURE';
export const ADD_PENDING_WAITLIST_PROGRAMS = 'ADD_PENDING_WAITLIST_PROGRAMS';
export const ADD_PENDING_WAITLIST_PROGRAMS_SUCCESS = 'ADD_PENDING_WAITLIST_PROGRAMS_SUCCESS';
export const ADD_PENDING_WAITLIST_PROGRAMS_FAILURE = 'ADD_PENDING_WAITLIST_PROGRAMS_FAILURE';
export const SAVE_ADDITIONAL_QUESTIONS = 'SAVE_ADDITIONAL_QUESTIONS';
export const SAVE_ADDITIONAL_QUESTIONS_SUCCESS = 'SAVE_ADDITIONAL_QUESTIONS_SUCCESS';
export const SAVE_ADDITIONAL_QUESTIONS_FAILURE = 'SAVE_ADDITIONAL_QUESTIONS_FAILURE';
export const GET_SR_ADDITIONAL_QUESTIONS_SUCCESS = 'GET_SR_ADDITIONAL_QUESTIONS_SUCCESS';
export const GET_SR_ADDITIONAL_QUESTIONS_FAILURE = 'GET_SR_ADDITIONAL_QUESTIONS_FAILURE';

// GOAT
export const SET_GOAT = 'SET_GOAT';
export const GOAT_API_REQUEST = 'GOAT_API_REQUEST';
export const GOAT_API_SUCCESS = 'GOAT_API_SUCCESS';
export const GOAT_API_FAILURE = 'GOAT_API_FAILURE';

export const SET_ADMISSION_INSTANCES = 'SET_ADMISSION_INSTANCES';

export const SET_ADMISSION_PROCESSES = 'SET_ADMISSION_PROCESSES';
export const ADD_ADMISSION_PROCESSES = 'ADD_ADMISSION_PROCESSES';
export const ADMISSION_PROCESS_API_REQUEST = 'ADMISSION_PROCESS_API_REQUEST';
export const ADMISSION_PROCESS_API_SUCCESS = 'ADMISSION_PROCESS_API_SUCCESS';
export const ADMISSION_PROCESS_API_FAILURE = 'ADMISSION_PROCESS_API_FAILURE';

export const STUDENT_API_REQUEST_BY_ID = 'STUDENT_API_REQUEST_BY_ID';
export const STUDENT_API_SUCCESS_BY_ID = 'STUDENT_API_SUCCESS_BY_ID';
export const STUDENT_API_FAILURE_BY_ID = 'STUDENT_API_FAILURE_BY_ID';

export const SCHOOL_EVENTS_REQUEST_API = 'SCHOOL_EVENTS_REQUEST_API';
export const SCHOOL_EVENTS_SUCCESS_API = 'SCHOOL_EVENTS_SUCCESS_API';
export const SCHOOL_EVENTS_FAILURE_API = 'SCHOOL_EVENTS_FAILURE_API';